/**
 * Initialise Flickity + filtrage/scroll robustes (scroll TOUJOURS vers #product-and-metric)
 */
function initFlickity() {
  var elem = document.querySelector('.dawn-product-slider .carousel');
  if (!elem) return;

  var flkty = new Flickity(elem, {
    contain: true,
    imagesLoaded: true,
    lazyLoad: 2,
    wrapAround: true,
    pageDots: false,
  });

  function updateSiblings() {
    var allCells = document.querySelectorAll('.dawn-product-slider .carousel-cell');
    allCells.forEach(cell => cell.classList.remove('is-next', 'is-prev', 'is-selected'));
    var selectedIndex = flkty.selectedIndex;
    var prevIndex = (selectedIndex - 1 + allCells.length) % allCells.length;
    var nextIndex = (selectedIndex + 1) % allCells.length;
    allCells[selectedIndex].classList.add('is-selected');
    allCells[prevIndex].classList.add('is-prev');
    allCells[nextIndex].classList.add('is-next');
  }

  flkty.on('select', updateSiblings);

  var allCells = document.querySelectorAll('.dawn-product-slider .carousel-cell');
  allCells.forEach((cell, index) => {
    cell.addEventListener('click', function() {
      flkty.select(index);
    });
  });

// Gestion filtrage/scroll par handle Shopify (scroll contextuel selon catégorie)
document.querySelectorAll('.about-collection-btn[data-collection]').forEach(btn => {
  btn.addEventListener('click', function() {
    const handle = btn.getAttribute('data-collection');
    // Filtrage par radio handle Shopify
    const radio = document.querySelector('input[type="radio"][name="category"][value="' + handle + '"]');
    if (radio) {
      radio.checked = true;
      if (typeof filterProducts === 'function') {
        filterProducts();
      } else {
        radio.dispatchEvent(new Event('change', {bubbles:true}));
      }
    }
    // Scroll contextuel
    if (['outils', 'accessoires', 'accessory', 'accessories'].includes(handle.toLowerCase())) {
      // Scroll uniquement vers Accessories-Innovation
      const section = document.getElementById('shopify-section-template--23917679509818__accessories_and_innovation_ALXHdr');
      if(section) {
        section.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
    } else {
      // Scroll uniquement vers la section produits/metrics pour les autres catégories
      const section = document.getElementById('product-and-metric');
      if(section) {
        section.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
    }
    document.querySelectorAll('.about-collection-btn[data-collection]').forEach(b => {
      b.classList.toggle('active', b === btn);
    });
  });
});

  // Initial class setup
  updateSiblings();
}

window.addEventListener('load', function() {
  initFlickity();
  if (typeof appendRating === 'function') appendRating();

  const prevButton = document.querySelector('.flickity-button.flickity-prev-next-button.previous');
  if (prevButton) {
    prevButton.innerHTML = `
      <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.166672 21C0.166672 32.5 9.5 41.8333 21 41.8333C32.5 41.8333 41.8333 32.5 41.8333 21C41.8333 9.49996 32.5 0.166626 21 0.166626C9.5 0.166626 0.166672 9.49996 0.166672 21ZM37.6667 21C37.6667 30.2083 30.2083 37.6666 21 37.6666C11.7917 37.6666 4.33334 30.2083 4.33334 21C4.33334 11.7916 11.7917 4.33329 21 4.33329C30.2083 4.33329 37.6667 11.7916 37.6667 21ZM12.6667 21L21 12.6666L23.9375 15.6041L20.6458 18.9166H29.3333V23.0833H20.6458L23.9583 26.3958L21 29.3333L12.6667 21Z" fill="#00392F"/>
      </svg>
    `;
  }

  const nextButton = document.querySelector('.flickity-button.flickity-prev-next-button.next');
  if (nextButton) {
    nextButton.innerHTML = `
      <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M41.8333 21C41.8333 9.49996 32.5 0.166626 21 0.166626C9.49996 0.166626 0.166626 9.49996 0.166626 21C0.166626 32.5 9.49996 41.8333 21 41.8333C32.5 41.8333 41.8333 32.5 41.8333 21ZM4.33329 21C4.33329 11.7916 11.7916 4.33329 21 4.33329C30.2083 4.33329 37.6666 11.7916 37.6666 21C37.6666 30.2083 30.2083 37.6666 21 37.6666C11.7916 37.6666 4.33329 30.2083 4.33329 21ZM29.3333 21L21 29.3333L18.0625 26.3958L21.3541 23.0833H12.6666V18.9166H21.3541L18.0416 15.6041L21 12.6666L29.3333 21Z" fill="#00392F"/>
      </svg>
    `;
  }
});



document.addEventListener('DOMContentLoaded', () => {
    // Select DOM elements
    const products = document.querySelectorAll('.main-bigpharma--products .bigpharma-product');
    const nameFilters = document.querySelectorAll('.filter-name');
    const gammeFilter = document.getElementById('filter-gamme');
    const ratingFilter = document.getElementById('filter-rating');
    const categoryFilterContainers = document.querySelectorAll('.filter-category-container');
    const tagsFilter = document.getElementById('filter-tags');
    const aromesFilter = document.getElementById('filter-aromes');

    // Message to display when no products are found
    const noProductMessage = document.createElement('p');
    noProductMessage.className = 'no-product-founded-box';
    noProductMessage.textContent = 'No Product Found';
    document.querySelector('.main-bigpharma--products .bigpharma-product-box-all-products').appendChild(noProductMessage);
    noProductMessage.style.display = 'none';

    const filterSection = document.getElementById('shopify-section-template--23917679509818__bigpharma_products_filter_wFrkGt');

    // Helper function to get unique values
    const getUniqueValues = (selector, attribute) => {
        const values = new Set();
        products.forEach(product => {
            if (attribute) {
                const attrValue = product.getAttribute(attribute);
                if (attrValue) values.add(attrValue.trim());
            } else {
                product.querySelectorAll(selector).forEach(element => {
                    values.add(element.textContent.trim());
                });
            }
        });
        return Array.from(values).filter(Boolean); // Remove empty values
    };

    // Helper function to format stars for ratings
    const formatStars = (rating) => {
        const numericRating = parseInt(rating, 10);
        if (!isNaN(numericRating)) {
            const stars = '★'.repeat(numericRating) + '☆'.repeat(5 - numericRating);
            return `${numericRating} ${stars}`;
        }
        return rating;
    };

    // Populate filter dropdowns
    const populateFilter = (filterElement, values, placeholder, formatFn) => {
        values = [...new Set(values)]; // Ensure unique values
        values.sort(); // Sort values
        filterElement.innerHTML = `<option value="">${placeholder}</option>`;
        values.forEach(value => {
            const displayValue = formatFn ? formatFn(value) : value;
            filterElement.innerHTML += `<option value="${value}">${displayValue}</option>`;
        });
    };

    // Populate category filters with images and titles (robuste via handle Shopify)
    // Convention : chaque radio value = handle Shopify, jamais le texte affiché !
    // Les sections cibles pour le scroll doivent avoir id="section-{handle}" ou data-section="{handle}"
    const populateCategoryFilters = () => {
        const uniqueCategories = new Map();

        // Extract unique categories with their titles, images, and handles
        products.forEach(product => {
            const categoryElements = product.querySelectorAll('.bigpharma-product--categories .bigpharma-product-category');
            categoryElements.forEach(categoryElement => {
                const titleElement = categoryElement.querySelector('.bigpharma-product-category-title');
                const imageElement = categoryElement.querySelector('img');
                const handle = titleElement ? titleElement.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') : null;
                if (titleElement && handle) {
                    uniqueCategories.set(handle, {
                        title: titleElement.textContent.trim(),
                        image: imageElement ? imageElement.src : null,
                        handle
                    });
                }
            });
        });

        const categories = Array.from(uniqueCategories.values());

        categoryFilterContainers.forEach(container => {
            container.innerHTML = '';

            // Create the "All Categories" option
            const allOption = document.createElement('div');
            allOption.classList.add('all-categories');
            allOption.innerHTML = `
                <label>
                    <input type="radio" name="category" value="" checked>
                    All Categories
                </label>`;
            container.appendChild(allOption);

            // Create options for each category
            categories.forEach(({ title, image, handle }) => {
                const option = document.createElement('div');
                option.classList.add(handle);
                option.innerHTML = `
                    <label>
                        <input type="radio" name="category" value="${handle}">
                        ${image ? `<img src="${image}" alt="${title}" class="category-filter-image">` : ''}
                        <span>${title}</span>
                    </label>`;
                container.appendChild(option);
            });
        });
    };

    // Exemple de structure cible pour les sections à scroller :
    // <div id="section-thc-plus">...</div>
    // <div id="section-cbd">...</div>
    // <div id="section-0-thc">...</div>
    // <div id="section-accessoires">...</div>
    // Ou bien : <div data-section="thc-plus">...</div>

    // Populate filters with unique values
    populateFilter(gammeFilter, getUniqueValues('.bigpharma-product--gamme-items p', null), 'Gamme');
    populateFilter(ratingFilter, getUniqueValues(null, 'data-rating'), 'Avis ☆☆☆☆☆', formatStars);
    populateFilter(tagsFilter, getUniqueValues('.bigpharma-product-product-tags li', null), 'Effet');
    populateFilter(aromesFilter, getUniqueValues('.bigpharma-product--aromes p', null), 'Arôme');
    populateCategoryFilters();

    // Scroll to filter section
    const scrollToFilterSection = () => {
        if (filterSection) {
            filterSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    };

    // Filter products
    const filterProducts = () => {
        const nameValues = Array.from(nameFilters)
            .map(input => input.value.toLowerCase())
            .filter(value => value);

        const gammeValue = gammeFilter.value;
        const ratingValue = ratingFilter.value;
        const tagsValue = tagsFilter.value;
        const aromesValue = aromesFilter.value;

        const categoryValue = document.querySelector('input[name="category"]:checked')?.value || '';

        let hasVisibleProducts = false;

        products.forEach(product => {
            const productName = product.getAttribute('data-name') || '';
            const gammeMatch = !gammeValue || (product.getAttribute('data-gamme') === gammeValue);
            const nameMatch = !nameValues.length || nameValues.some(val => productName.toLowerCase().includes(val));
            const ratingMatch = !ratingValue || (product.getAttribute('data-rating') === ratingValue);
            const tagsMatch = !tagsValue || (product.getAttribute('data-tags') || '').split(',').includes(tagsValue);
            const aromesMatch = !aromesValue || (product.getAttribute('data-aromes') || '').split(',').includes(aromesValue);

            // Filtrage robuste : compare le handle généré côté produit avec le handle sélectionné
            const categoryHandles = Array.from(product.querySelectorAll('.bigpharma-product--categories .bigpharma-product-category-title'))
                .map(el => el.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''));
            const categoryMatch = !categoryValue || categoryHandles.includes(categoryValue);

            if (gammeMatch && nameMatch && ratingMatch && tagsMatch && aromesMatch && categoryMatch) {
                product.style.display = '';
                hasVisibleProducts = true;
            } else {
                product.style.display = 'none';
            }
        });

        noProductMessage.style.display = hasVisibleProducts ? 'none' : 'block';
    };

    // Attach event listeners
    nameFilters.forEach(input => {
        input.addEventListener('input', filterProducts);
    });

    gammeFilter.addEventListener('change', filterProducts);
    ratingFilter.addEventListener('change', filterProducts);
    tagsFilter.addEventListener('change', filterProducts);
    aromesFilter.addEventListener('change', filterProducts);

    // Category filters
    document.addEventListener('change', (event) => {
        if (event.target.name === 'category') {
            const selectedHandle = event.target.value.toLowerCase();
            // Scroll uniquement si ce n'est PAS outils/accessoires
            if (!['outils', 'accessoires', 'accessory', 'accessories'].includes(selectedHandle)) {
                scrollToFilterSection();
            } else {
                // Scroll accessoires/outils → Accessories-Innovation
                const section = document.getElementById('shopify-section-template--23917679509818__accessories_and_innovation_ALXHdr');
                if(section) {
                    section.scrollIntoView({behavior: 'smooth', block: 'start'});
                }
            }
            setTimeout(filterProducts, 500); // Ensure scroll finishes
        }
    });
});










document.addEventListener('DOMContentLoaded', () => {
window.onload = () => {
    setTimeout(() => {
        // Add <a> tags to .accessories inside .filter-category-container
        const categoryFilterContainers = document.querySelectorAll('.filter-category-container');
        categoryFilterContainers.forEach(container => {
            const accessories = container.querySelectorAll('.accessories');
            accessories.forEach(accessory => {
                const link = document.createElement('a');
                link.href = '#shopify-section-template--23917679509818__accessories_and_innovation_ALXHdr';
                link.textContent = 'Accessories';
                accessory.appendChild(link);
            });
        });

        // Scroll to section function
        const filterSection = document.querySelector('#shopify-section-template--23917679509818__accessories_and_innovation_ALXHdr');
        const scrollToFilterSection = () => {
            if (filterSection) {
                filterSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        };

        // Example usage of the scroll function
        // scrollToFilterSection(); // Uncomment to test the scroll function
    }, 1000); // 1-second delay
};
});











document.addEventListener("DOMContentLoaded", function () {
  const productsContainer = document.querySelector(".accessoires-bigpharma--products .bigpharma-product-box-all-products");
  const productsx = document.querySelectorAll(".accessoires-bigpharma--products .bigpharma-product");

  if (!productsContainer || productsx.length === 0) {
    console.warn("Products container or products not found");
    return;
  }

  const nameFilter = document.getElementById("accessoris-filter-name");
  const ratingFilterx = document.getElementById("accessoris-filter-rating");
  const priceFilter = document.getElementById("accessoris-filter-price");
  const priceLabel = document.createElement("span");
  priceFilter.parentElement.appendChild(priceLabel);

  const ratings = [];
  const prices = [];

  // Extract data for filtering
  productsx.forEach((product) => {
    const rating = product.getAttribute("data-rating"); // Get rating directly
    const priceText = product.querySelector(".accessoires-bigpharma--products .bigpharma-product--price")?.textContent.trim();
    const price = parseFloat(priceText?.replace("€", "").replace(",", ".")) || 0;

    if (rating) ratings.push(parseFloat(rating)); // Push numeric rating
    if (price) prices.push(price);
  });

  // Debug: Log all collected ratings
  console.log("Collected Ratings:", ratings);

  // Populate rating filter dropdown
  const uniqueRatings = [...new Set(ratings)]; // Remove duplicates
  uniqueRatings.sort((a, b) => a - b).forEach((rating) => {
    const option = document.createElement("option");
    option.value = rating;
    option.textContent = `Rating: ${rating} stars`;
    ratingFilterx.appendChild(option);
  });

  // Set up price range slider based on product prices
  const minPrice = Math.min(...prices);
  const maxPrice = Math.max(...prices);

  priceFilter.min = minPrice;
  priceFilter.max = maxPrice;
  priceFilter.step = 1;
  priceFilter.value = maxPrice;

  function updatePriceLabel() {
    const value = priceFilter.value;
    priceLabel.textContent = `€${parseFloat(value).toFixed(2)}`;
  }

  // Filter products based on selected rating, name input, and price
  function filterProductx() {
    const selectedRating = parseFloat(ratingFilterx.value) || NaN; // Allow empty value for rating
    const maxPriceValue = parseFloat(priceFilter.value);
    const searchText = nameFilter.value.toLowerCase().trim(); // Get input text

    productsx.forEach((product) => {
      const productName = product.querySelector(".accessoires-bigpharma--products .bigpharma-product--title a")?.textContent.toLowerCase().trim();
      const rating = parseFloat(product.getAttribute("data-rating"));
      const priceText = product.querySelector(".accessoires-bigpharma--products .bigpharma-product--price")?.textContent.trim();
      const price = parseFloat(priceText?.replace("€", "").replace(",", ".")) || 0;

      // Debug: Log the rating, price, and product name
      console.log("Product Name:", productName, "Product Rating:", rating, "Product Price:", price);

      // Check if the product matches the selected rating, price, and input text
      const matchesRating = isNaN(selectedRating) || rating === selectedRating || selectedRating === 0;
      const matchesPrice = price <= maxPriceValue;
      const matchesName = searchText === "" || productName.includes(searchText);

      // Show or hide the product based on the filter conditions
      if (matchesRating && matchesPrice && matchesName) {
        product.style.display = "";
      } else {
        product.style.display = "none";
      }
    });
  }

  // Attach event listeners for filter changes
  nameFilter.addEventListener("input", filterProductx);
  ratingFilterx.addEventListener("change", filterProductx);
  priceFilter.addEventListener("input", function () {
    filterProductx();
    updatePriceLabel();
  });

  // Initial population of products and price label update
  filterProductx();
  updatePriceLabel();
});





document.addEventListener("DOMContentLoaded", function () {
    const menuLinks = document.querySelectorAll("a#HeaderMenu-a-propos, a#HeaderMenu-nous-contacter, #big-pharma-propos-de-nonus, #big-pharma-guid-du-cbd, #big-pharma-blog, #big-pharma-faq, #big-pharma-contact, #big-pharma-conditions-generales, #big-pharma-politique-de-confidentialite, .mobile-hamburger-icon");
    const loginLinks = document.querySelectorAll("#account-toggle");
    const panel = document.querySelector(".big-pharma-left-side-panel");
    const closeButtons = document.querySelectorAll("button#big-pharma-left-panel-close-btn");
    const hamburgerIcon = document.querySelector('.mobile-hamburger-icon');

    hamburgerIcon.addEventListener('click', function() {
        this.classList.toggle('active');
    });
    
    // Add class when menu links are clicked
    menuLinks.forEach(link => {
        link.addEventListener("click", function () {
            if (panel) {
                panel.classList.add("active"); // Replace "active" with your desired class name
            }
        });
    });

  // login links are clicked
    loginLinks.forEach(link => {
        link.addEventListener("click", function () {
            if (panelRight) {
                panelRight.classList.add("active"); // Replace "active" with your desired class name
            }
        });
    });

    // Remove class when any close button is clicked
    closeButtons.forEach(button => {
        button.addEventListener("click", function () {
            if (panel && panel.classList.contains("active")) {
                panel.classList.remove("active"); // Replace "active" with your desired class name
            }
            if (hamburgerIcon && hamburgerIcon.classList.contains("active")) {
                hamburgerIcon.classList.remove("active"); // Replace "active" with your desired class name
            }
        });
    });


    // Handle specific buttons and their actions
    const panelInner = document.querySelector(".big-pharma-left-side-panel-inner");

    // Updated approach with querySelectorAll for the buttons that have the same ID
    const buttonActions = [
        {
            id: "big-pharma-propos-de-nonus",
            target: "#bigPharmaAboutUsBox"
        },
        {
            id: "big-pharma-left-panel-back-main-btn",
            target: "#bigPharmaMainInfoBox"
        },
        {
            id: "big-pharma-guid-du-cbd",
            target: "#bigPharmaGuidBox"
        },
        {
            id: "big-pharma-blog",
            target: "#bigPharmaBlogBox"
        },
        {
            id: "big-pharma-faq",
            target: "#bigPharmaFaqBox"
        },
        {
            id: "big-pharma-contact",
            target: "#bigPharmaContactBox"
        },
        {
            id: "big-pharma-conditions-generales",
            target: "#bigPharmaGerenalConditionBox"
        },
        {
            id: "big-pharma-politique-de-confidentialite",
            target: "#bigPharmapolicyBox"
        },
        {
            id: "big-pharma-left-panel-footer-btn",
            target: "#bigPharmaContactBox"  // Fix here for footer button
        },
        {
            id: "mobile-hamburger-icon",
            target: "#bigPharmaAboutUsBox"  // Fix here for footer button
        }
    ];

    buttonActions.forEach(action => {
        // Use querySelectorAll to select all buttons with the same ID
        const buttons = document.querySelectorAll(`#${action.id}`);  // Using querySelectorAll here
        const target = document.querySelector(action.target);

        if (buttons.length && panelInner && target) {
            buttons.forEach(button => {
                button.addEventListener("click", function () {
                    // Remove class from all .big-pharma-left-side-panel-inner elements
                    const allPanelInners = document.querySelectorAll(".big-pharma-left-side-panel-inner");
                    allPanelInners.forEach(inner => {
                        inner.classList.remove("panel-open");
                    });

                    // Add class to the target element
                    target.classList.add("panel-open");
                });
            });
        }
    });
});



document.addEventListener('DOMContentLoaded', function () {
    const menu = document.querySelector('.search-bar-boxx-menu');
    const link = menu.querySelector('a');
    const input = menu.querySelector('.filter-name');

    // Add 'active' class to the menu when the link is clicked
    link.addEventListener('click', function (e) {
        e.preventDefault(); // Prevent default link behavior
        menu.classList.add('active'); // Add the 'active' class

        // Smooth scroll to the section
        const targetId = this.getAttribute('href').slice(1); // Remove '#' from href
        const targetSection = document.getElementById(targetId);

        if (targetSection) {
            targetSection.scrollIntoView({ behavior: 'smooth' });
        }
    });

    // Remove 'active' class and clear text when clicking outside
    document.addEventListener('click', function (e) {
        if (!menu.contains(e.target)) {
            menu.classList.remove('active'); // Remove the 'active' class
        }
    });
});


document.addEventListener("DOMContentLoaded", function() {
    document.getElementById("reset-filters").addEventListener("click", function() {
        // Reset text input
        document.getElementById("filter-name").value = "";

        // Reset all select elements
        document.querySelectorAll("#filter-gamme, #filter-tags, #filter-aromes, #filter-rating").forEach(select => {
            select.selectedIndex = 0;
        });

        // Show all products by removing 'display: none;'
        document.querySelectorAll(".bigpharma-product-box-all-products .bigpharma-product").forEach(product => {
            product.style.display = ""; // Resets to default display
        });
    });
});




document.addEventListener("DOMContentLoaded", function() {
    // Select all elements that have the class for the images
    const images = document.querySelectorAll('.big-pharma-container-hero-section img');

    // Function to generate a random duration between min and max values (in seconds)
    function getRandomDuration(min, max) {
        return (Math.random() * (max - min) + min).toFixed(2) + 's';
    }

    // Loop through each image and apply a random duration to its animation
    images.forEach((image, index) => {
        // Random duration between 4s and 15s (you can adjust the range)
        const randomDuration = getRandomDuration(4, 15);
        
        // Apply the random duration as the animation duration
        image.style.animationDuration = randomDuration;
    });
});
